<template>
  <ul class="flex items-center flex-col gap-[24px] md:w-[49%] xl:w-[100%]">
    <!--    <li
      class="flex items-center font-semibold text-lg text-[#242D21] border-background last:border-none w-full"
      :class="{
        'flex-row-reverse gap-6 justify-end': isOpenCategories,
        'justify-between flex-row': !isOpenCategories,
      }"
      @click="handleCategoriesList"
    >
      {{ $t("common.categories") }}

      <icon-arrow
        class="text-[15px] text-primary"
        :class="{
          'rotate-[90deg]': !isOpenCategories,
          'rotate-[270deg]': isOpenCategories,
        }"
      ></icon-arrow>
    </li>-->
    <li v-show="isOpenCategories" class="w-full text-lg border-background last:border-none pl-[8px]">
      <MenuCategoryList class="md:w-[372px]" @close-mobile-menu="$emit('close-menu')" />
    </li>
    <template v-if="!isOpenCategories">
      <!--      <li
        class="font-semibold text-lg text-[#242D21] w-full items-center border-background last:border-none hover:text-primary"
      >
        <router-link
          class="font-semibold text-lg text-[#242D21]"
          :to="{
            name: '/how-it-works',
          }"
          @click="$emit('close-mobile-menu')"
        >
          {{ $t("how-it-works-page.title") }}
        </router-link>
      </li>-->
      <li
        class="font-semibold text-lg text-[#242D21] w-full items-center border-background last:border-none hover:text-primary"
      >
        <router-link
          :to="{ name: '/programs' }"
          class="font-semibold text-lg text-[#242D21]"
          @click="$emit('close-mobile-menu')"
        >
          {{ $t("common.workshops") }}
        </router-link>
      </li>
      <li
        class="font-semibold text-lg text-[#242D21] w-full items-center border-background last:border-none hover:text-primary"
      >
        <router-link
          :to="{ name: '/partnership' }"
          class="font-semibold text-lg text-[#242D21]"
          @click="$emit('close-mobile-menu')"
        >
          {{ $t("common.partners") }}
        </router-link>
      </li>
      <li
        class="font-semibold text-lg text-[#242D21] w-full items-center border-background last:border-none hover:text-primary"
      >
        <router-link
          :to="{
            name: '/investment-deck',
          }"
          class="font-semibold text-lg text-[#242D21]"
          @click="$emit('close-mobile-menu')"
        >
          {{ $t("common.investment-deck") }}
        </router-link>
      </li>
        <li class="font-semibold text-[18px] text-[#242D21] w-full items-center border-background last:border-none hover:text-primary">
            <router-link
                :to="{
                        name: '/franchising',
                    }"
                class="font-semibold text-[18px] text-[#242D21]"
                @click="$emit('close-mobile-menu')"
            >
                {{ $t("common.franchising") }}
            </router-link>
        </li>
      <li
        class="font-semibold text-lg text-[#242D21] w-full items-center border-background last:border-none hover:text-primary"
      >
        <router-link
          :to="{
            name: '/about',
          }"
          class="font-semibold text-lg text-[#242D21]"
          @click="$emit('close-mobile-menu')"
        >
          {{ $t("common.about-us") }}
        </router-link>
      </li>
      <li
        class="font-semibold text-lg text-[#242D21] w-full items-center border-background last:border-none hover:text-primary"
      >
        <router-link
          :to="{
            name: '/contacts',
          }"
          class="font-semibold text-lg text-[#242D21]"
          @click="$emit('close-mobile-menu')"
        >
          {{ $t("common.contact-us") }}
        </router-link>
      </li>
    </template>
  </ul>
  <ul class="border-t-2 border-[#F3F3F3] md:mt-[60px] mt-[40px] pb-4">
    <li
      v-for="link in footerLinks"
      :key="link.title"
      class="my-4 w-full items-center border-background last:border-none hover:text-primary"
    >
      <router-link
        v-if="!link.isOuterLink"
        :to="{ path: link.routeName }"
        class="font-normal text-lg text-[#242D21]"
      >
        {{ $t(link.title) }}
      </router-link>
      <a
        v-else
        :href="link.routeName"
        class="font-normal text-lg text-[#242D21] link hover:text-primary"
        target="_blank"
      >
        {{ $t(link.title) }}
      </a>
    </li>
    <!--    <li
      class="my-4 w-full items-center border-background last:border-none hover:text-primary"
    >
      <a
        :href="promoLink"
        class="text-lg"
        type="application/pdf"
        download
        >{{ $t("footer.promo-text") }}</a
      >
    </li>-->
    <!--    <FooterSocialList class="w-full mt-7" />-->
    <li class="my-4 w-full items-center border-background last:border-none hover:text-primary">
      <span class="text-[14px] text-[#8E8E8E]">Copyright © 2026 — Kidpreneurs.academy</span>
    </li>
  </ul>
</template>

<script setup>
import { computed, ref } from "vue"
import MenuCategoryList from "./MenuCategoryList.vue"
// import FooterSocialList from "@/components/footer/FooterSocialList.vue";
import footerNav from "@/static/footer-nav"
// import {useI18n} from "vue-i18n";

// import {PUBLIC_URL} from "@/api/urls";
// import IconArrow from "components/icons/IconArrow.vue";

defineEmits({
  "close-mobile-menu": null,
  "open-partner-form": null,
})

// const { locale } = useI18n();

const isOpenCategories = ref(false)

const footerLinks = computed(() => {
  return footerNav.reduce((acc, block) => {
    acc.push(...block.links.filter((link) => !link.hideOnMobile))
    return acc
  }, [])
})

/*const handleCategoriesList = () => {
  console.log(footerLinks);
  isOpenCategories.value = !isOpenCategories.value;
};*/

/*const promoLink = computed(() => {
  return `${PUBLIC_URL}pdf/promo/${locale.value}.pdf`;
});*/
</script>
